var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-account-info',{attrs:{"accountInfo":_vm.accountInfo},on:{"signOut":_vm.onSignOut,"changePassword":_vm.onChangePassword}})}
var staticRenderFns = []

export { render, staticRenderFns }